// extracted by mini-css-extract-plugin
export var clauseRow = "_5g-6";
export var emptyState = "_5g-d";
export var filterContent = "_5g-a";
export var filterGroup = "_5g-1";
export var filterGroupContainer = "_5g-0";
export var nestedGroup = "_5g-2";
export var nestedGroupContent = "_5g-b";
export var nestedGroupDepth1 = "_5g-3";
export var nestedGroupDepth2 = "_5g-4";
export var nestedGroupDepth3 = "_5g-5";
export var nestedGroupEmpty = "_5g-c";
export var operatorAnd = "_5g-8";
export var operatorOr = "_5g-9";
export var operatorToggle = "_5g-7";
export var removeGroupButton = "_5g-e";